// extracted by mini-css-extract-plugin
module.exports = {"wiki-content-desc-box":"_1LiA","title":"_2ftk","content":"_2M1u"};